import React from "react";
import Button from "components/BaseWidgets/button";
import "./style.scss";
import { getWebsiteUrl } from "utils/formatHelper";
import { truncateText } from "./helper";
import { Tooltip } from "antd";
import useMediaQuery from "hooks/useMediaQuery";

const JewelryBannerCard = ({ data }) => {
  const heading = data?.heading || "";
  const isTruncated = heading.length > 20;
  const isMobileSmall = useMediaQuery("(max-width: 575px)");

  const truncateLength = isMobileSmall ? 9 : 20;

  return (
    <div
      className="jewelry-banner"
      style={{
        backgroundImage: `url(${data?.image})`,
      }}
    >
      <p className="subheading font-title-xxs">{data?.store_name}</p>
      {isTruncated ? (
        <Tooltip title={heading}>
          <span className="main-heading font-title-large">
            {truncateText(heading, truncateLength)}
          </span>
        </Tooltip>
      ) : (
        <span className="main-heading font-title-large">{heading}</span>
      )}

      <Button
        onClick={() =>
          window.open(
            getWebsiteUrl(data?.website),
            "_blank",
            "noopener,noreferrer"
          )
        }
        target="_blank"
        rel="noopener noreferrer"
        variant="link"
        className="book-button"
      >
        BOOK NOW
      </Button>
    </div>
  );
};

export default JewelryBannerCard;
